import gql from 'graphql-tag';

export default gql`
query getAllPagesOfProjectById($projectId: Int!) {
  projects_by_pk(project_id: $projectId) {
    child_pages {
      name
      slug
    }
  }
}
`;
